export default "__VITE_ASSET__D6E8oKKm__"